import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Modal, Row, Spinner } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import API from "../../common/API";
import moment from "moment";
import { Routes } from "../../routes";
import Pagination from "../core/Pagination";
import { useTranslation } from "react-i18next";

interface VehicleVisit {
    id?: string | number;
    visitDate?: string | null;
    vehicleName?: string | null;
    siteId?: string | number | null;
    siteName?: string | null;
    assignedTo?: string | null;
    assignedToId?: string | null;
}

interface Props {
    show: boolean;
    toggle: () => void;
}

const VehicleDetails: React.FC<Props> = ({ show, toggle }) => {
    const { t } = useTranslation("global");
    const { id } = useParams<{ id: string }>();
    const [records, setRecords] = useState<VehicleVisit[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [quantityOfPages, setQuantityOfPages] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [quantityOfRecords, setQuantityOfRecords] = useState<number>(0);
    const bindData = async (page?: number) => {
        try {
            setIsLoading(true);
            let query = `page=${page}&vehicleId=${id}`;
            const request = await API.getAction(`vehicleVisits/list?${query}`);
            const data = request?.data;
            if (data && data.status === "ok" && Array.isArray(data.response)) {
                setRecords(data.response as VehicleVisit[]);
                setQuantityOfPages(data.quantityOfPages);
                // setCurrentPage(data.page);
                setQuantityOfRecords(data.quantityOfRecords);
            } else {
                setRecords([]);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error loading vehicle visits:", e);
            setRecords([]);
        } finally {
            setIsLoading(false);
        }
    }
    const onPageChanged = (obj: number) => {
        setCurrentPage(obj);
    };

    useEffect(() => {
        if (show) bindData(currentPage);
    }, [show]);

    useEffect(() => {
        bindData(currentPage);
        console.log("Current Page:", currentPage);
    }, [currentPage])
    return (
        <Modal show={show} onHide={toggle} size="xl" className="modalRight">
            <Modal.Header closeButton>
                <Row className="mx-0 w-100">
                    <Col>
                        <div className="d-flex align-items-center">
                            <h3 className="mb-0 me-3">{t("Vehicle Details")}
                            </h3>
                        </div>
                    </Col>
                </Row>
            </Modal.Header>

            <Modal.Body className="p-0" style={{ overflow: "auto" }}>
                <Container>
                    {isLoading ? (
                        <div className="d-flex justify-content-center py-4">
                            <Spinner animation="border" role="status" />
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>{t("Date")}</th>
                                        <th>{t("Vehicle")}</th>
                                        <th>{t("Location")}</th>
                                        <th>{t("Assigned To")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {records.length === 0 ? (
                                        <tr>
                                            <td colSpan={3} className="text-center text-muted py-3">
                                                {t("No records found")}
                                            </td>
                                        </tr>
                                    ) : (
                                        records.map((record, index) => {
                                            const key = record.id ?? `${record.siteId ?? 'site'}-${index}`;
                                            return (
                                                <tr key={key}>
                                                    <td title={record.visitDate ?? ''}>
                                                        {record.visitDate ? moment(record.visitDate).fromNow() : '—'}
                                                    </td>
                                                    <td>{record.vehicleName ?? '—'}</td>
                                                    <td>
                                                        <Link to={`${Routes.PlaceDetails.clean}${record.siteId ?? ''}`}>
                                                            {record.siteName ?? '—'}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        {record.assignedTo !== null ? record.assignedTo : '—'}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Pagination
                    totalPages={quantityOfPages}
                    currentPage={currentPage}
                    onPageChanged={onPageChanged}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default VehicleDetails;
